<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         :viewBox="viewBox" style="enable-background:new 0 0 107.6 126.5;" xml:space="preserve">
        <component :is="component" v-if="component" :settings="settings" />
    </svg>
</template>

<script>

    import Eye1 from './Eye1';

    export default {
        name: 'EyePreview',
        components: { Eye1 },
        props: {
            isPreview: {
                type: Boolean,
                required: false,
                default () {
                    return false;
                },
            },
            settings: {
                type: Object,
                required: true,
            },
            eyes: {
                type: String,
                required: true,
            },
        },
        data () {
            return {
                component: null,
            }
        },
        computed: {
            viewBox () {
               return this.isPreview ? '30 25 45 35' : '0 0 107.6 126.5';
            },
            loader () {
                return () => {
                    return import(`./${this.eyes}`);
                }
            },
        },
        mounted () {
            this.loader()
                .then(() => {
                    this.component = () => this.loader()
                });
        },
    }
</script>
